import { jsx as e } from "react/jsx-runtime";
import { lazy as t, Suspense as i } from "react";
import { Box as n, CircularProgress as o } from "@mui/material";
const f = t(() => import("./PdfViewer.js").then((r) => ({ default: r.PdfViewer })));
function a(r) {
  return /* @__PURE__ */ e(i, { fallback: /* @__PURE__ */ e(n, { sx: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }, children: /* @__PURE__ */ e(o, {}) }), children: /* @__PURE__ */ e(f, { ...r }) });
}
export {
  a as PdfViewer
};
//# sourceMappingURL=index.js.map
